<template>
    <q-no-ssr>
        <div class="">

            <HeroSection />

            <ThreeStepsSection />

            <SolutionsComparison />

            <FeaturesSlider />

            <WebsiteExamples :homeStatsData="homeStatsData" :statisticsLoader="statisticsLoader" />

  

            <BusinessFeatures />

            <FirstSaudiTool />

            <KSABenefits />

            <SecuritySection />

            <FAQSection :faqList="faqList" />

            <!-- <CTASection /> -->
        </div>
    </q-no-ssr>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive } from 'vue';
import { ISiteCards } from '@/types/ISiteCards';
import { useSearchStore } from '@/stores/search';
import { handleErrorFunc } from '@/boot/error-handler';
import { randomSites } from '@/services/search-service';
import HeroSection from '@/components/ui/HeroSection.vue';
import ThreeStepsSection from '@/components/ui/ThreeStepsSection.vue';
import SolutionsComparison from '@/components/ui/SolutionsComparison.vue';
import FeaturesSlider from '@/components/ui/FeaturesSlider.vue';
import WebsiteExamples from '@/components/ui/WebsiteExamples.vue';
import EarnMoney from '@/components/ui/EarnMoney.vue';
import BusinessFeatures from '@/components/ui/BusinessFeatures.vue';
import FirstSaudiTool from '@/components/ui/FirstSaudiTool.vue';
import KSABenefits from '@/components/ui/KSABenefits.vue';
import SecuritySection from '@/components/ui/SecuritySection.vue';
import FAQSection from '@/components/ui/FAQSection.vue';
import CTASection from '@/components/ui/CTASection.vue';
import { useMeta } from 'quasar';
import { useRoute } from 'vue-router';

const route = useRoute();
const searchStore = useSearchStore();
const statisticsLoader = ref<boolean>(true);
const homeStatsData = ref<ISiteCards>();

// Using useMeta with setup syntax
useMeta(route.meta)

const faqList = reactive([
    {
        question: '1. ' + 'وش أسرع حل لتقييم التجربة الرقمية لموقعي؟',
        answer: 'المقيّم الخبير! سواء موقعك جاهز على البيئة الحية أو لا يزال نموذج أولي، تقدر تطلب تقييم سريع من خبير مختص في المجال اللي تبيه – تصميم، محتوى، تجربة المستخدم، أو حتى هيكلة المعلومات – وتاخذ رأي احترافي يساعدك تطور منتج الرقمي بسرعة وفعالية.'
    },
    {
        question: '2. ' + 'من هو المقيم الخبير؟',
        answer: 'المقيّم الخبير هو متخصص معتمد في أكواد ويعمل تحت إشرافها. خبير في أحد مجالات تجربة المستخدم مثل تصميم واجهات الاستخدام، أو كتابة تجربة المستخدم، أو هيكلة المعلومات وغيرها من الجوانب المهمة لتحسين التجربة الرقمية.'
    },
    {
        question: '3. ' + 'هل أقدر أجرب مختبر أكواد؟',
        answer: 'أكيد! اشترك في مختبر أكواد وابدأ أول شهر كفترة تجريبية مجانية. جرب كل المميزات وتعرّف أكثر على المختبر وكيفية عمل الأداة.'

    },
    {
        question: '4.' + 'كيف أستفيد من التقييم العام؟',
        answer: 'تقدر تطّلع على آراء وتقييمات المستخدمين على أي موقع، مع صورة تحدد لك أي صفحة يتكلمون عنها! وحتى أنت تقدر تقيّم وتكتب تعليقاتك على أي موقع تبيه وتساهم في تحسين التجربة الرقمية.'

    },
    {
        question: '5. ' + 'كيف أحمل الأداة؟ وهل هي آمنة؟',
        answer: 'حجم الأداة ما يتجاوز 300 كيلوبايت، تقدر تحملها على متصفح google chrome وتجدها في الإمدادات” أو الإضافات (Extensions) وتقدر بعد كذا تستخدمها في أي موقع.'
    },

]);

const getHomeStatistics = () => {
    try {
        homeStatsData.value = searchStore.getRandomSites();
        statisticsLoader.value = false;
    } catch (error: any) {
        handleErrorFunc(error);
    }
};

onMounted(async () => {
    const randomSitesData = await randomSites();
    randomSitesData.data.random_top_websites = randomSitesData.data?.random_top_websites.slice(0, 5);
    searchStore.setRandomSites(randomSitesData.data);
    getHomeStatistics();

})

</script>

<style scoped lang="scss"></style>